import React, { useContext } from 'react';

export const SurveyContext = React.createContext({
  surveyFormStep: 0,
  setSurveyFormStep: () => {},
  form1Data: { website: '', role: '' },
  setForm1Data: () => {},
  form2Data: { whySaral: '', saralReferal: '' },
  setForm2Data: () => {},
  form3Data: { revenue: '', objective: '', teamSize: '' },
  setForm3Data: () => {},
  form1V2Data: { winForBrand: '', roadblocks: '' },
  setForm1V2Data: () => {},
  form2V2Data: { objective: '' },
  setForm2V2Data: () => {},
  userType: 'v2',
  setUserType: () => {},
});

export const useSurveyContext = () => {
  const context = useContext(SurveyContext);

  return {
    ...context,
    totalSteps: context?.userType === 'v1' ? 4 : 3,
  };
};
